import { atom } from 'recoil';

export const completionModalState = atom({
  key: 'completionModalState', 
  default: {
    open:false,
    duration:0
  }, 
});